import { GlIcon, GlLink, GlPopover, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, n__, sprintf } from '~/locale';
import { createAlert } from '../../../alert.js?vue3';
import HelpIcon from '../../../vue_shared/components/help_icon/help_icon.vue?vue3';
import { convertToGraphQLId, getIdFromGraphQLId } from '~/graphql_shared/utils';
import { TYPENAME_ISSUE } from '~/graphql_shared/constants';
import { DOCS_URL } from '~/constants';
import getIssueCrmContactsQuery from '../../queries/get_issue_crm_contacts.query.graphql';
import issueCrmContactsSubscription from '../../queries/issue_crm_contacts.subscription.graphql';
export default {
    name: 'CrmContacts',
    crmDocsLink: `${DOCS_URL}/user/crm/`,
    components: {
        GlIcon,
        GlLink,
        GlPopover,
        HelpIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        issueId: {
            type: String,
            required: true
        },
        groupWorkItemsPath: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            contacts: []
        };
    },
    apollo: {
        contacts: {
            query: getIssueCrmContactsQuery,
            variables () {
                return this.queryVariables;
            },
            update (data) {
                return data?.issue?.customerRelationsContacts?.nodes;
            },
            error (error) {
                createAlert({
                    message: __('Something went wrong trying to load work item contacts.'),
                    error,
                    captureError: true
                });
            },
            subscribeToMore: {
                document: issueCrmContactsSubscription,
                variables () {
                    return this.queryVariables;
                },
                updateQuery (prev, { subscriptionData }) {
                    const draftData = subscriptionData?.data?.issueCrmContactsUpdated;
                    if (prev && draftData) return {
                        issue: draftData
                    };
                    return prev;
                }
            }
        }
    },
    computed: {
        shouldShowContacts () {
            return this.contacts?.length;
        },
        queryVariables () {
            return {
                id: convertToGraphQLId(TYPENAME_ISSUE, this.issueId)
            };
        },
        contactsLabel () {
            return sprintf(n__('%{count} contact', '%{count} contacts', this.contactCount), {
                count: this.contactCount
            });
        },
        contactCount () {
            return this.contacts?.length || 0;
        }
    },
    methods: {
        shouldShowPopover (contact) {
            return this.popOverData(contact).length > 0;
        },
        divider (index) {
            if (index < this.contactCount - 1) return ',';
            return '';
        },
        popOverData (contact) {
            return [
                contact.organization?.name,
                contact.email,
                contact.phone,
                contact.description
            ].filter(Boolean);
        },
        getWorkItemsPath (contactId) {
            const id = getIdFromGraphQLId(contactId);
            return `${this.groupWorkItemsPath}?crm_contact_id=${id}`;
        }
    }
};
